import { Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { Fragment, ReactNode, useEffect, useState } from 'react';
import Badgev2 from '../badge/Badgev2';
import { useFilterContext } from './hooks';

type FilterContainerProps = {
    title: string;
    isOpen: boolean;
    activeFilterCount: number;
    children: ReactNode | ReactNode[];
};

function FilterContainer({ title, isOpen, children, activeFilterCount }: FilterContainerProps): JSX.Element {
    const filterInstance = useFilterContext();
    const [open, setOpen] = useState(isOpen);

    useEffect(() => {
        if (filterInstance.allClosed) {
            setOpen(false);
        }
    }, [filterInstance.allClosed]);

    return (
        <div className="max-w-[300px]">
            <button
                onClick={(): void => {
                    filterInstance.resetAllClosed();
                    setOpen(!open);
                }}
                className={`${
                    open ? 'font-medium' : ''
                } w-full flex items-center justify-between cursor-pointer text-sm px-4 py-2 dark:hover:bg-white/[0.09] hover:bg-gray-50`}
            >
                <div className="flex gap-2">
                    <p className="flex items-center gap-2">{title}</p>
                    {activeFilterCount > 0 && <Badgev2 color="indigo" label={activeFilterCount.toString()} size="small" shape="rounded" />}
                </div>

                <ChevronDownIcon className={`w-5 h-5 ${open ? 'rotate-180' : ''}`} />
            </button>

            {/* <Transition
                show={open}
                as={Fragment}
                enter="transition-[height] ease-out duration-1000"
                enterFrom="transform"
                enterTo="transform"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            > */}
            {open && <div className="dark:bg-white/[0.04] bg-gray-100">{children}</div>}
            {/* </Transition> */}
        </div>
    );
}

export default FilterContainer;
